export default {
    list: 'user/list',
    byId: 'user/byId',
    accountManagers: 'user/accountManagers',
    add: 'user/add',
    
    isEmailUsed: 'user/isEmailUsed',
    isUsernameUsed: 'user/isUsernameUsed',
    isContactNumberUsed: 'user/isContactNumberUsed',

    disable: 'user/disable',
    enable: 'user/enable',

    changeDetails: 'user/changeDetails'
};
